import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';
import AnimatedDigit from '@components/CountdownComponent/_AnimatedDigit';

interface TimeSegment {
  value: string;
  type?: string;
}

interface TimerBlockProps {
  darkMode: boolean;
  currentSegments: Array<TimeSegment>;
  prevSegments: Array<TimeSegment>;
  description?: string;
  className?: string;
  isAnimating: boolean;
  title?: string;
}

const TimerBlock = ({
  darkMode,
  currentSegments,
  prevSegments,
  description,
  className,
  isAnimating,
}: TimerBlockProps) => {
  return (
    <div
      data-testid="timer-block"
      className={classNames(
        'flex flex-col items-center justify-center text-center transition-opacity duration-1000 ease-in-out px-5',
        isAnimating ? 'opacity-0' : 'opacity-100',
        className,
      )}
    >
      <div className={classNames(darkMode ? 'text-white' : 'text-gray-800')}>
        <h2 className={classNames('tra-text-web-heading-1 flex items-center justify-center gap-1')}>
          {currentSegments.map((segment, index) => (
            <React.Fragment key={index}>
              <div className="inline-flex items-center">
                {segment.value.split('').map((digit, i) => (
                  <AnimatedDigit
                    key={i}
                    value={digit}
                    prev={(prevSegments[index]?.value || segment.value)?.split('')[i] || digit}
                  />
                ))}
                {index < currentSegments.length - 1 && <span className="mt-1 mx-1">:</span>}
              </div>
            </React.Fragment>
          ))}
        </h2>
      </div>
      <hr
        className={classNames('border-2 w-10 border-brand-300 my-4 transition-opacity ease-in-out')}
      />
      {description && (
        <p
          className={classNames(
            'tra-text-web-body-xl max-w-[700px]',
            darkMode ? 'text-white' : 'text-gray-800',
          )}
        >
          {description}
        </p>
      )}
    </div>
  );
};

export default TimerBlock;
